import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types/database.ts";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || "VITE_SUPABASE_URL_PLACEHOLDER";
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "VITE_SUPABASE_ANON_KEY_PLACEHOLDER";

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    // Must be true so the client picks up the access_token from the URL
    // hash after a Magic Link redirect (e.g. /#access_token=...). Otherwise
    // the user lands back on the page but never gets a session.
    detectSessionInUrl: true,
  },
});

// Type-safe database operations
export type Tables<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Row"];
export type Inserts<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Insert"];
export type Updates<T extends keyof Database["public"]["Tables"]> =
  Database["public"]["Tables"][T]["Update"];

// Convenience types
export type Profile = Tables<"profiles">;
export type Tip = Tables<"tips">;
export type League = Tables<"leagues">;
export type TipV2 = Tables<"tips_v2">;
